import * as React from "react";
import styled from "styled-components";

import i18n from "../../lib/i18n";
import { media } from "../../common/utils/style";
import Carousel from "../../common/components/Carousel";
import Translate from "../../common/components/Translate";
import { NavigatableSection, SectionInner, SectionTitle } from "./Section";
import StartActionCard from "./StartActionCard";
import EditableCardWrapper from "./EditableCardWrapper";
import PortfolioProjectCard, {
  PortfolioProjectCardModels,
} from "../../portfolio_projects/components/PortfolioProjectCard";

type PortfolioProject = PortfolioProjectCardModels["PortfolioProject"];

export interface PortfolioSectionModels {
  PortfolioProject: PortfolioProject;
}

interface Props {
  projects: PortfolioProject[];
  editable?: boolean;
  locale: string;
}

const PortfolioSection: React.SFC<Props> = props => {
  const { projects, editable, locale } = props;
  const hasContent = projects.length > 0;
  if (!hasContent && !editable) {
    return null;
  }
  return (
    <NavigatableSection
      id="portfolio"
      displayName={i18n.translate("company.home.sections.portfolio", {
        locale,
      })}
    >
      <SectionInner>
        <SectionTitle>
          <Translate id="company.home.sections.portfolio" />
        </SectionTitle>
      </SectionInner>
      {editable &&
        !hasContent && (
          <StartActionCard
            message={i18n.translate("company.home.start_portfolio_card.message", { locale })}
            subMessage={i18n.translate("company.home.start_portfolio_card.sub_message", {
              locale,
            })}
            buttonText={i18n.translate("company.home.start_portfolio_card.button_text", {
              locale,
            })}
            linkPath="https://case.wantedly.com/portfolio/projects/new"
            targetBlank
          />
        )}
      {hasContent && (
        <ProjectsList>
          <CarouselWrapper>
            <Carousel
              layouts={{
                small: { perPage: 1, gutter: 16 },
                medium: { perPage: 2, gutter: 16 },
                large: { perPage: 1.5, gutter: 30 },
              }}
              childCount={projects.length}
              renderChild={(index, isActive) => {
                const project = props.projects[index];
                return (
                  <EditableCardWrapper editable={editable} editLink={`${project.canonical_url}/edit`}>
                    <PortfolioProjectCard project={project} floatsByHover={isActive} />
                  </EditableCardWrapper>
                );
              }}
            />
          </CarouselWrapper>
        </ProjectsList>
      )}
    </NavigatableSection>
  );
};

const ProjectsList = styled.div`
  overflow-x: hidden;
`;

const CarouselWrapper = styled(SectionInner)`
  margin: 0 30px 0 16px;
  @media ${media.large} {
    margin: 0 auto;
  }
`;

export default PortfolioSection;



// WEBPACK FOOTER //
// ./frontend/src/companies/components/PortfolioSection.tsx